if (!customElements.get("before-after-image-slider")) {
  customElements.define(
    "before-after-image-slider",
    class BeforeAfterImageSlider extends HTMLElement {
      constructor() {
        super();
        this.hasAnimated = false;
        this.isAnimating = false;
      }

      connectedCallback() {
        this.mediaWrapper = this.querySelector("[data-media-wrapper]");
        this.inputSlider = this.querySelector("[data-input-slider]");

        if (!this.mediaWrapper || !this.inputSlider) return;

        this._syncValue = this.syncValue.bind(this);
        this.inputSlider.addEventListener("input", this._syncValue);
        this.inputSlider.addEventListener("pointerdown", this._syncValue);

        this.syncValue();
        this.setupIntersectionObserver();
      }

      disconnectedCallback() {
        if (this.inputSlider) {
          this.inputSlider.removeEventListener("input", this._syncValue);
          this.inputSlider.removeEventListener("pointerdown", this._syncValue);
        }
        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
        }
      }

      syncValue() {
        if (this.isAnimating) return;

        const value =
          (Number(this.inputSlider.value) - Number(this.inputSlider.min)) /
          (Number(this.inputSlider.max) - Number(this.inputSlider.min));
        const compareValue = Math.round(value * 100);

        this.mediaWrapper.style.setProperty(
          "--before-after-value",
          String(compareValue)
        );
      }

      animateSlider() {
        if (this.hasAnimated) return;

        this.hasAnimated = true;
        this.isAnimating = true;

        this.mediaWrapper.style.setProperty("--before-after-duration", "0.5s");

        setTimeout(
          () =>
            this.mediaWrapper.style.setProperty("--before-after-value", "40"),
          100
        );

        setTimeout(
          () =>
            this.mediaWrapper.style.setProperty("--before-after-value", "60"),
          600
        );

        setTimeout(
          () =>
            this.mediaWrapper.style.setProperty("--before-after-value", "50"),
          1100
        );

        setTimeout(() => {
          this.mediaWrapper.style.setProperty("--before-after-duration", "0s");
          this.inputSlider.value = "50";
          this.isAnimating = false;
        }, 1600);
      }

      setupIntersectionObserver() {
        if (!window.IntersectionObserver) return;

        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !this.hasAnimated) {
                setTimeout(() => this.animateSlider(), 300);
                this.intersectionObserver.disconnect();
              }
            });
          },
          { threshold: 0.5 }
        );

        this.intersectionObserver.observe(this);
      }
    }
  );
}
